import { render, staticRenderFns } from "./invoiceTerm.vue?vue&type=template&id=4b19714a"
import script from "./invoiceTerm.vue?vue&type=script&lang=js"
export * from "./invoiceTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports